import { useCallback, useEffect, useState } from "react";

export function usePathname(): [string, (path: string) => void] {
  const [pathname, setPathname] = useState(() => window.location.pathname || "/");

  useEffect(() => {
    const onPopState = (): void => {
      setPathname(window.location.pathname);
    };

    window.addEventListener("popstate", onPopState);
    return () => {
      window.removeEventListener("popstate", onPopState);
    };
  }, []);

  const navigate = useCallback((path: string) => {
    window.history.pushState({}, "", path);
    setPathname(path);
  }, []);

  return [pathname, navigate];
}

export function matchRecipesRoute(pathname: string):
  | { view: "list" }
  | { view: "new" }
  | { view: "import" }
  | { view: "detail"; recipeId: string }
  | { view: "edit"; recipeId: string }
  | { view: "cook"; recipeId: string; sessionId: string }
  | undefined {
  if (pathname === "/recipes" || pathname === "/recipes/") {
    return { view: "list" };
  }

  if (pathname === "/recipes/new") {
    return { view: "new" };
  }

  if (pathname === "/recipes/import") {
    return { view: "import" };
  }

  const cookMatch = /^\/recipes\/([^/]+)\/cook\/([^/]+)$/.exec(pathname);
  if (cookMatch !== null) {
    return { view: "cook", recipeId: cookMatch[1], sessionId: cookMatch[2] };
  }

  const editMatch = /^\/recipes\/([^/]+)\/edit$/.exec(pathname);
  if (editMatch !== null) {
    return { view: "edit", recipeId: editMatch[1] };
  }

  const detailMatch = /^\/recipes\/([^/]+)$/.exec(pathname);
  if (detailMatch !== null) {
    return { view: "detail", recipeId: detailMatch[1] };
  }

  return undefined;
}
